var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "page"
    }
  }, [_c("div", [_c("regionListComponent", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };